import { INVENTARIO_ESTADO } from "../constants";

/**
 * Recuento por estado de una lista de inventarios, para las fichas de estadísticas
 * @param {Array<{estado: string}>} inventarios - Inventarios ya filtrados por fecha y preparador
 * @returns {{porEstado: Object<string, number>, total: number}} Recuento por INVENTARIO_ESTADO y total
 */
export const contarPorEstado = (inventarios = []) => ({
    porEstado: Object.fromEntries(
        Object.values(INVENTARIO_ESTADO).map((estado) => [estado, inventarios.filter((item) => item.estado === estado).length])
    ),
    total: inventarios.length,
});

/**
 * Filtra por estado; sin estado devuelve la misma lista
 * @param {Array<{estado: string}>} inventarios - Inventarios a filtrar
 * @param {string} estado - INVENTARIO_ESTADO o "" para todos
 * @returns {Array} Inventarios en ese estado
 */
export const filtrarPorEstado = (inventarios = [], estado = "") =>
    estado ? inventarios.filter((item) => item.estado === estado) : inventarios;
